<template>
  <div id="chart-table-box">
    <div class="chart-title">
      <img class="charts-icon" :src="require('@/assets/images/largescreen/charts-icon.png')" alt="">
      <dv-decoration-1/>
      <span>{{ areaName === 'china' ? '全国' : areaName }}TOP20终端数据</span>
    </div>
    <dv-scroll-board id="chart-table" :config="config"/>
  </div>
</template>

<script>
import resize from '@/utils/resize'
export default {
  mixins: [resize],
  name: "bodyRightCenter",
  props: {
    areaName: {
      type: String,
      default: 'china'
    },
    top10Equipment: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      chart: null,
      top10EquipmentDataList: [],
      config: {}
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.setConfig()
    })
    
    // 监听屏幕方向变化
    window.addEventListener('orientationchange', this.handleOrientationChange)
  },
  watch: {
    top10Equipment: {
      handler(val) {
        var arr = []
        
        // ✅ 优化：如果没有数据，显示提示信息
        if (!val || val.length === 0) {
          arr.push([
            '<span style="color: #999;">-</span>',
            '-',
            '<span style="color: #999;">暂无数据</span>',
            '-',
          ])
        } else {
          for (var i = 0; i < val.length; i++) {
            // 对医院名称进行处理,如果太长则截断并添加title属性
            let hospitalName = val[i].equipmentName || '';
            let displayHospitalName = `<span title="${hospitalName}">${hospitalName}</span>`;
            
            arr.push([
              '<span>' + val[i].ranking + '</span>',
              val[i].province,
              displayHospitalName,
              val[i].YTD || '-',
            ])
          }
        }
        
        this.top10EquipmentDataList = arr
        this.setConfig()
      },
      deep: true,
      immediate: true // ✅ 确保初始数据也能渲染
    }
  },
  beforeDestroy() {
    // 移除监听器
    window.removeEventListener('orientationchange', this.handleOrientationChange)
  },
  methods: {
    handleOrientationChange() {
      // 屏幕方向变化后，延迟重新渲染
      setTimeout(() => {
        // DataV 表格组件会自动适应容器大小
      }, 300)
    },
    setConfig() {
      this.config = {
        header: ['排名', '省份', '医院', 'YTD'],
        data: this.top10EquipmentDataList,
        columnWidth: [60, 90, 220, 70], // ✅ 优化列宽分配：增加医院名称和YTD的宽度
        headerBGC: 'rgba(36, 203, 241, .1)',
        oddRowBGC: 'rgba(125, 155, 243, .2)',
        evenRowBGC: 'rgba(125, 155, 243, .2)',
        rowNum: 10,
        align: ['center', 'center', 'left', 'center'] // 医院左对齐,数值右对齐
      }
    },
  }
}
</script>

<style lang="scss" scoped>
#chart-table-box {
  background: rgba(125, 155, 243, .2);
  height: 33.4%;
  .chart-title {
    display: flex;
    align-items: center; // ✅ 垂直居中对齐
    color: #fff;
    font-weight: bolder;
    padding: 5px 10px;
    background: rgba(125, 155, 243, .2);
    position: relative;

    .charts-icon{
      width: 20px;
      height: 25px;
      position: absolute;
      left: 15px;
      top: 0;
    }
    .dv-decoration-1 {
      width: 50px;
      height: 18px;
    }
  }

  #chart-table {
    padding: 0;
    height: calc(100% - 30px);
  }
}

// 平板端和手机横屏适配
@media screen and (min-width: 769px) {
  #chart-table-box {
    .chart-title {
      span {
        font-size: 12px !important;
      }
    }
  }
}

// 手机横屏特殊处理
@media screen and (orientation: landscape) and (max-height: 768px) {
  #chart-table-box {
    height: calc((100% - 30px) / 3) !important; // ✅ 三等分，减去边距和padding
    margin-bottom: 10px !important;
  }
}

// 手机竖屏适配
@media screen and (max-width: 768px) and (orientation: portrait) {
  #chart-table-box {
    height: 280px !important;
    margin-bottom: 10px;
    
    .chart-title {
      padding: 8px 10px !important;
      
      span {
        font-size: 13px !important;
        margin-left: 35px !important;
      }
      
      .charts-icon {
        width: 16px !important;
        height: 20px !important;
        left: 10px !important;
      }
      
      .dv-decoration-1 {
        width: 40px !important;
        height: 15px !important;
      }
    }
    
    #chart-table {
      padding: 0 !important;
      height: calc(100% - 30px) !important;
    }
  }
}

// ✅ 1080p 屏幕专属优化
@media screen and (min-width: 1920px) and (max-width: 2560px) and (min-height: 1080px) and (max-height: 1440px) {
  #chart-table-box {
    .chart-title {
      span {
        font-size: 18px !important; // ✅ 增大标题字体
      }
      
      .charts-icon {
        width: 24px !important;
        height: 30px !important;
      }
      
      .dv-decoration-1 {
        width: 70px !important;
        height: 24px !important;
      }
    }
    
    // 表格内容字体优化
    ::v-deep .dv-scroll-board .header .header-item {
      font-size: 14px !important;
      padding: 0 5px !important;
    }
    ::v-deep .dv-scroll-board .rows .ceil {
      font-size: 13px !important;
      padding: 0 5px !important;
    }
  }
}
</style>
<style>
.dv-scroll-board {
  width: 100% !important;
}
.dv-scroll-board .header {
  width: 100% !important;
}
.dv-scroll-board .rows {
  width: 100% !important;
}
.dv-scroll-board .header .header-item{
  padding: 0 5px!important;
  font-size: 11px;
  font-weight: bold;
}
.dv-scroll-board .rows .ceil{
  padding: 0 5px!important;
  font-size: 10px;
  /* 文本溢出处理 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media screen and (max-width: 768px) {
  .dv-scroll-board .header .header-item{
    padding: 0 2px!important;
    font-size: 9px !important;
  }
  .dv-scroll-board .rows .ceil{
    padding: 0 2px!important;
    font-size: 8px !important;
  }
}
</style>
